import { render, staticRenderFns } from "./DeliveryListRootPage.vue?vue&type=template&id=750827a1&scoped=true&"
import script from "./DeliveryListRootPage.vue?vue&type=script&lang=js&"
export * from "./DeliveryListRootPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750827a1",
  null
  
)

export default component.exports